import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
    },
    finalize: function() {
      const section = document.querySelector( '[data-component="project-estimate-cta"]' );
      if ( !section ) return;

      const house = section.querySelector( '.cta__house-graphic' );
      const pills = gsap.utils.toArray( section.querySelectorAll( '.cta__pill' ) );

      gsap.set( house, {
        autoAlpha: 0,
        y: 40,
      } );

      pills.forEach( ( pill ) => {
        const isRight =
          pill.className.includes( 'right-' ) ||
          getComputedStyle( pill ).flexDirection === 'row-reverse';

        const line = pill.querySelector( '.cta__pill-line' );
        const inner = pill.querySelector( '.cta__pill-line__inner' );
        const dot = pill.querySelector( '.cta__pill-dot' );

        gsap.set( pill, {
          autoAlpha: 0,
          x: isRight ? 40 : -40,
        } );

        if ( line ) {
          gsap.set( line, {
            scaleX: 0,
            transformOrigin: isRight ? 'right center' : 'left center',
          } );
        }

        if ( inner ) {
          gsap.set( inner, {
            scaleY: 0,
            transformOrigin: 'bottom center',
          } );
        }

        if ( dot ) {
          gsap.set( dot, {
            scale: 0,
            transformOrigin: 'center center',
            willChange: 'transform',
          } );
        }
      } );

      const tl = gsap.timeline( {
        scrollTrigger: {
          trigger: section,
          start: 'top 70%',
          toggleActions: 'play none none none',
        },
      } );

      tl.to( house, {
        autoAlpha: 1,
        y: 0,
        duration: 0.8,
        ease: 'power3.out',
      } );

      pills.forEach( ( pill ) => {
        const line = pill.querySelector( '.cta__pill-line' );
        const inner = pill.querySelector( '.cta__pill-line__inner' );
        const dot = pill.querySelector( '.cta__pill-dot' );

        const pillTl = gsap.timeline();

        pillTl.to( pill, {
          autoAlpha: 1,
          x: 0,
          duration: 0.5,
          ease: 'power3.out',
        } );

        if ( line ) {
          pillTl.to( line, {
            scaleX: 1,
            duration: 0.4,
            ease: 'power2.out',
          } );
        }

        if ( inner ) {
          pillTl.to( inner, {
            scaleY: 1,
            duration: 0.35,
            ease: 'power2.out',
          } );
        }

        if ( dot ) {
          pillTl.to( dot, {
            scale: 1,
            duration: 0.25,
            ease: 'back.out(2)',
          } );
        }

        tl.add( pillTl );
      } );
    },
  };
  app.registerComponent( 'project-estimate-cta', COMPONENT );
} )( app );
